export default "__VITE_ASSET__c14VFvRP__"